import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthContext.js'; // Adjust the path as needed

export function ProtectedRoute({ children }) {
    const auth = useAuth();

    // Show loading state while checking authentication
    // This prevents premature redirect when refreshing the page
    if (auth.isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                color: '#6b7280'
            }}>
                Loading...
            </div>
        );
    }

    // Replace the condition below with your logic to check if the user is authenticated
    if (!auth.currentUser) {
        // Redirect to login page or show an appropriate message
        return <Navigate to="/login" />;
    }

    return children;
}
